<template>
  <div class="page">
    <div class="container">
      <div class="tabs">
        <el-tabs v-model="testTabs.value" @tab-click="handleClickTabs" center>
          <el-tab-pane
            v-for="item in testTabs.list"
            :key="item.value"
            :label="item.label"
            :name="item.value"
          >
            <!-- 入学测试 -->
            <template v-if="item.value === '1'">
              <el-form
                :inline="true"
                :model="form"
                label-width="100px"
                @submit.native.prevent
              >
                <el-form-item
                  label=""
                  style="min-width: 220px;padding-left: 30px;"
                >
                  <el-input
                    v-model="form.paper_name"
                    placeholder="请输入您想要搜索的试卷名称"
                    size="small"
                    clearable
                    @keyup.enter.native="search"
                  ></el-input>
                </el-form-item>
                <el-form-item style="padding-left: 15px;">
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    size="small"
                    @click="search"
                    >查询</el-button
                  >
                </el-form-item>
                <el-form-item style="padding-left: 15px;">
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    size="small"
                    @click="CreatePaper"
                    >新增试卷</el-button
                  >
                </el-form-item>
              </el-form>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="block-list">
        <subunitTestPaper
          :examlist="examlist"
          v-if="examlist.join('') !== ''"
          @methodEditQuestions="EditQuestions"
          @methodLookPaper="LookPaper"
          @methodPaperCopy="PaperCopy"
          @methoddeletePaper="deletePaper"
          @methodStartExam="StartExam"
        />
        <subunitEmpty v-else />
        <div class="pagination" v-if="examlist.join('') !== ''">
          <div class="pagination-box">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.page_no"
              background
              :page-sizes="[12, 24, 36, 48]"
              :page-size="form.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="form.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="新增题库" :visible.sync="dialogVisible" width="40%">
      <el-form
        class="form-style"
        :model="form"
        size="mini"
        label-position="left"
      >
        <el-form-item label="序号" required prop="sort_num">
          <el-input-number
            v-model="form.sort_num"
            :precision="0"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="所属科目" required prop="subject_id">
          <el-select v-model="form.subject_id" placeholder="请选择" filterable>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) of subjectList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="题库名称" required prop="title">
          <el-input v-model="form.title" placeholder="请输入名称"></el-input>
        </el-form-item>

        <el-form-item label="简介" required>
          <el-input
            type="textarea"
            v-model="form.desc"
            placeholder="请输入题库的简介"
          ></el-input>
        </el-form-item>

        <el-form-item label="封面" required prop="img_url">
          <el-upload
            action=""
            :http-request="uploadFile"
            :on-remove="handleRemove"
            :on-change="handleChangeFile"
            :auto-upload="false"
            :limit="1"
            :file-list="form.imgList"
            list-type="picture"
          >
            <el-button size="mini" type="primary" plain
              >点击上传<i class="el-icon-upload el-icon--right"></i
            ></el-button>
            <div slot="tip" class="el-upload__tip">
              <span style="color: red">推荐尺寸(750*340)</span>
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import subunitTestPaper from '../subunitComponents/subunitTestPaper.vue'
import subunitEmpty from '../subunitComponents/subunitEmpty.vue'
import { getSchoolPaperList, deletePaper, copyPaper } from '@/api/educational'
export default {
  // 试卷中心页面
  name: 'CompetitionCenter-TestPaperCenter',
  components: {
    subunitTestPaper,
    subunitEmpty,
  },
  data: () => ({
    testTabs: {
      value: '1',
      list: [{ label: '试卷管理', value: '1' }],
    },
    examlist: [],
    //试卷搜索
    form: {
      paper_name: '',
      subject_id: '',
      search_user_id: '',
      owned: true,
      page_no: 1,
      page_size: 12,
      total: 0,
    },
    subjectList: [],
    dialogVisible: false, //新增题库
    initialEntry: true,
  }),
  mounted() {
    this.getSchoolPaperList()
    this.initialEntry = false
    console.log('动起来')
  },
  activated() {
    if (this.initialEntry) {
      this.getSchoolPaperList()
      console.log('出发了')
    }
  },
  methods: {
    handleClickTabs(tab, e) {
      console.log(tab, e)
    },
    handleSizeChange(val) {
      this.page_size = val
      this.search()
    },
    search() {
      this.form.page_no = 1
      this.getSchoolPaperList()
    },

    getSchoolPaperList() {
      getSchoolPaperList({
        title: this.form.paper_name,
        subject_id: this.form.subject_id,
        isShowSelfPaper: this.form.owned,
        search_user_id: this.form.search_user_id,
        page_no: this.form.page_no,
        page_size: this.form.page_size,
      }).then((res) => {
        console.log('试卷列表')
        console.log(res)
        this.examlist = res.paperList
        this.form.total = res.total
      })
    },

    //删除试卷
    deletePaper(id) {
      this.$confirm('确定删除该试卷吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deletePaper({
          paper_id: id,
        }).then((res) => {
          if (res.is_delete) {
            this.$message.success('删除成功！')
            this.getSchoolPaperList()
          }
        })
      })
    },

    PaperCopy(id) {
      this.$prompt('请输入试卷副本的名称?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          if (value) {
            console.log('试卷副本名称')
            console.log(value)

            this.copyPaper(id, value)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消',
          })
        })
    },

    copyPaper(id, value) {
      copyPaper({
        paper_id: id,
        paper_title: value,
      }).then((res) => {
        console.log('复制试卷')
        console.log(res)
        if (res.is_create) {
          this.$message.success('试卷拷贝成功')
          this.getSchoolPaperList()
        }
      })
    },

    //添加试题
    AddQuestion(row) {
      console.log('添加试题')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-AddQuestion',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },
    QuestionManagement(row) {
      console.log('试题管理')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-Questionlist',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },
    Practice(row) {
      console.log('练习')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-Practice',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },

    CreatePaper() {
      console.log('创建考试')
      this.$router.push({
        name: 'CommonExam-CreatePaper',
      })
      this.initialEntry = true
    },

    LookPaper(row) {
      console.log('查看试卷')
      console.log(row)
      console.log('挑战模板1')
      console.log(this.project_url)

      let routeUrl = this.$router.resolve({
        name: 'CommonExam-PaperDetail',
        query: { id: row.id, title: row.title },
      })

      window.open(routeUrl.href, '_blank')
    },

    StartExam(row) {
      console.log('试卷参数')
      console.log(row)

      this.$router.push({
        name: 'CommonExam-StartExam',
        query: {
          id: row.id,
          subject_id: row.subject_id,
          total_num: row.total_num,
          total_score: row.total_score,
        },
      })
    },

    EditQuestions(row) {
      console.log('编辑试题')
      console.log(row)

      this.$router.push({
        name: 'CommonExam-EditQuestions',
        query: {
          id: row.id,
          title: row.title,
          bank_ids: row.questionBankIds,
        },
      })
    },

    handleCurrentChange(val) {
      this.form.page_no = val
      this.getSchoolPaperList()
    },
    handleChangeFile() {},
    handleRemove() {},
    uploadFile() {},
  },
}
</script>
<style scoped lang="scss">
.page {
  padding: 10px;
  .container {
    max-width: 1680px;
    margin: auto;
    .tabs {
      margin-bottom: 20px;
      border-radius: 5px;
      background-color: #fff;
      /deep/ .el-tabs {
        .el-tabs__header {
          position: initial;
          margin: 0 0 10px;
          .el-tabs__nav-wrap {
            padding-left: 28px;
            .el-tabs__nav-scroll {
              display: block;
              .el-tabs__nav {
                .el-tabs__item {
                  font-size: 16px;
                }
              }
            }
          }
        }
        .el-tabs__content {
        }
      }
      .el-form {
        .el-form-item {
          margin-bottom: 12px;
          /deep/ .el-form-item__content {
            width: 100%;
          }
        }
      }
    }
    .block-list {
      padding-bottom: 90px;
      .pagination {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background: rgba(255, 255, 255, 0.95);
        box-shadow: inset 1px 1px 0px 0px #ebedf0;
        .pagination-box {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          max-width: 1680px;
          height: 70px;
          padding: 0 50px;
          margin: auto;
          .el-pagination {
          }
        }
      }
    }
  }
}
</style>
